module.exports = __webpack_public_path__ + "static/img/m_nav_logo@3x.4e4b778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_nav_logo@3x.png
// module id = QxT9
// module chunks = 1